import type { MFARegister } from '../../../components/pages/userAccount/hsbc/steps/defaultRegistration/step_3/passwordSetupForm';
import type { ZustandStore } from '../../store.type';
import type { NamedSet } from 'zustand/middleware';

type HsbcRegistrationStep = { index: number; isCompleted: boolean };
export type StepsData = {
	tempPassword?: string;
	mfaOtp?: MFARegister['mfaOtp'];
	mfaSms?: MFARegister['mfaSms'];
	phoneSetup?: MFARegister['phoneSetup'];
	email?: string; // we keep this in memory to read from it on resend sms code
	// used in case user changes first and last names on invite
	user?: {
		firstName: string;
		lastName: string;
	};
};
type HsbcRegistrationStepsState = {
	steps: {
		collection: HsbcRegistrationStep[];
		currentStep: number;
		data: StepsData;
	};
};

type HsbcRegistrationStepsActions = {
	setStepsCollection: (steps: HsbcRegistrationStep[]) => void;
	setStepsData: (data: StepsData | null) => void;
	setCurrentStep: (currentStep: HsbcRegistrationStepsState['steps']['currentStep']) => void;
};

export type HsbcRegistrationStepsSlice = HsbcRegistrationStepsState & HsbcRegistrationStepsActions;

const hsbcRegistrationStepsInitialState: HsbcRegistrationStepsState = {
	steps: {
		collection: [
			{
				index: 0,
				isCompleted: true,
			},
		],
		currentStep: 0,
		data: {
			tempPassword: '',
		},
	},
};

export function hsbcRegistrationStepsSlice(set: NamedSet<ZustandStore>): HsbcRegistrationStepsSlice {
	return {
		...hsbcRegistrationStepsInitialState,

		setStepsCollection(steps: HsbcRegistrationStep[]): void {
			set(
				(state: HsbcRegistrationStepsState) => {
					state.steps.collection = steps.map((step, index) => ({
						...step,
						index,
						isCompleted: index === 0 ? true : step.isCompleted,
					}));
					return state;
				},
				false,
				'[setStepsCollection]',
			);
		},
		setStepsData(data: StepsData | null): void {
			set(
				(state: HsbcRegistrationStepsState) => {
					state.steps.data = { ...state.steps.data, ...data };
					return state;
				},
				false,
				'[setStepsData]',
			);
		},
		setCurrentStep(currentStep: HsbcRegistrationStepsState['steps']['currentStep']): void {
			set(
				(state: HsbcRegistrationStepsState) => {
					if (state.steps.collection[currentStep]) {
						state.steps.collection = state.steps.collection.map((step, index) => ({
							...step,
							isCompleted: index <= currentStep,
						}));
					}

					const stepToSet = state.steps.collection[currentStep];
					state.steps.currentStep = stepToSet ? stepToSet.index : 0;
					return state;
				},
				false,
				'[setCurrentStep]',
			);
		},
	};
}
